module.exports = __webpack_public_path__ + "static/OpenDyslexic3-Regular-0c774ed53507e9ecda3f9d9e96a504f5.ttf";